import {FileChip} from "../../../../../components/buttons/IconButtons";
import {DownloadProviderImage} from "../../../../../reduxToolkit/Providers/providersApi";
import {TABLES} from "../../../../../Apis/Tables";
import {
    EMPTY_VALUES,
    getDateFormat,
    getDateFromTimestamp,
    getDateTimeFromTimestamp, getTimeFromTimestamp
} from "../../../../../Apis/functions";
import {getFileIcon, getFileNameWithoutExtension} from "../../../../../Helpers/fileType";
import NotInformation from "../../../../../components/NotInformation";
import React from "react";
import {FIELD_TYPE} from "../../Type/Model/Model";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import CustomFileCard from "../../../../../components/CustomFileCard";
/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const FieldsCard = ({styles, data, t, dispatch,currentStatusConfig}) => {


    return (
        <>
            <div className={"d-flex justify-content-start mt-3"}>
                <div style={styles.container}>
                    <div style={styles.levelCard}>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p style={styles.level}>{t('visitor_type')} </p>
                        </div>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p style={styles.p}>{data?.invitation?.visitorType?.name}</p>
                        </div>
                    </div>
                    <div className={"p-16px"}>
                        <div
                            className={"p-16px background-shades-50 border-radius-8px border-full-shades-300 d-flex flex-column gap-36px"}>
                            <p className={"fs-20px ibl-font-w-600 justify-content-start d-flex "}>{t('overview')} </p>
                            <div className={"row d-flex align-items-center justify-content-center pl-30 pr-30"}>
                                {
                                    currentStatusConfig.id !== STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION ?
                                      data?.fields
                                          ?.filter(field => field.fieldType !== FIELD_TYPE.DOCUMENT.name)
                                          ?.map((item) => {
                                              return (
                                                  <>
                                                      <div className="col-6 d-flex flex-column justify-content-center align-items-center gap-2 mt-24px">
                                                          <p style={styles.title}>{item?.fieldName}</p>

                                                          { item?.value ? <>
                                                              { item.fieldType === FIELD_TYPE.DATE_TIME.name ? (
                                                                      <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                                                          {getDateTimeFromTimestamp(item.value)}
                                                                      </p>
                                                                  ) : item.fieldType === FIELD_TYPE.DATE.name ? (
                                                                      <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                                                          {getDateFromTimestamp(item.value)}
                                                                      </p>
                                                                  ) : item.fieldType === FIELD_TYPE.TIME.name ? (
                                                                      <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                                                          {getTimeFromTimestamp(item.value)}
                                                                      </p>
                                                                  ) : (
                                                                      <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                                                          {item.value}
                                                                      </p>
                                                                  )}
                                                              <p className={"justify-content-start d-flex ibl-font-w-400 fs-12px"}>{t('uploaded')}: {getDateFormat(item?.createdAt)} </p>
                                                          </>
                                                          : (
                                                              <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">{EMPTY_VALUES.DEFAULT}</p>
                                                          )}
                                                      </div>
                                                  </>
                                              )
                                          })
                                      : (
                                        <NotInformation card={false} text={t('no_documentation')} />
                                    )
                                }
                            </div>
                        </div>

                        <div className={"d-flex flex-column w-100 gap-3 pt-16px"}>
                            {
                                data?.fields
                                    ?.filter(field => field.fieldType === FIELD_TYPE.DOCUMENT.name)
                                    ?.map((item) => {
                                        const fileValue = item?.value;
                                        const Icon = fileValue?.trim() ? getFileIcon(fileValue) : FileChip;
                                        const title = getFileNameWithoutExtension(fileValue || (item?.fieldName) + " : "  + t('not_yet'));
                                        return (
                                            <CustomFileCard
                                                Icon={Icon}
                                                title={title}
                                                fileValue={fileValue}
                                                subtitle={fileValue?.trim() &&
                                                                <p className={"justify-content-start d-flex ibl-font-w-400 fs-12px"}>
                                                                    {t('uploaded')}: {getDateFormat(item?.createdAt)}
                                                                </p>
                                                }
                                                showChip={fileValue == null || fileValue === ''}
                                                buttonId={"btn_fc_download_" + item.id}
                                                onClick={() => {
                                                    dispatch(DownloadProviderImage({
                                                        id: item?.fieldSubmissionId,
                                                        option: TABLES.VISITOR_FIELD, // Option to download employee document
                                                        type: item?.value, // File path
                                                    }));
                                                }}
                                            />
                                        )
                                    })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default FieldsCard
